import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';


const HostResetPassword = () => {
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [formVisible, setFormVisible] = useState(true);

  const API = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();


  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tokenFromUrl = params.get('token');
    if (!tokenFromUrl) {
      setMessage('Invalid or missing token.');
      setMessageType('danger');
      setFormVisible(false);
    } else {
      setToken(tokenFromUrl);
    }
  }, []);

const handleSubmit = async (e) => {
  e.preventDefault();

  if (newPassword !== confirmPassword) {
    setMessage('Passwords do not match.');
    setMessageType('danger');
    return;
  }

  try {
    const response = await fetch(`${API}/api/host/reset-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token, newPassword }),
    });

    const data = await response.json();

    if (response.ok) {
      setMessage('Password has been reset successfully.');
      setMessageType('success');
      setFormVisible(false);

      
      setTimeout(() => {
        navigate('/cl');
      }, 2000);
    } else {
      setMessage(data.message || 'Failed to reset password.');
      setMessageType('danger');
    }
  } catch (error) {
    console.error(error);
    setMessage('Server error. Please try again later.');
    setMessageType('danger');
  }
};

  return (
    <div className="container d-flex align-items-center justify-content-center min-vh-100">
      <div className="col-md-6">
        <div className="card shadow p-4">
          <h3 className="text-center mb-4">Reset Password</h3>

          {message && (
            <div className={`alert alert-${messageType}`} role="alert">
              {message}
            </div>
          )}

          {formVisible && (
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="newPassword" className="form-label">New Password</label>
                <input
                  type="password"
                  className="form-control"
                  id="newPassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
                <input
                  type="password"
                  className="form-control"
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </div>

              <button type="submit" className="btn btn-primary w-100">
                Reset Password
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default HostResetPassword;
